import styled from "styled-components";

export const AboutWrap = styled.div`
    background-color: #e5e5e5;
    min-width: 300px;
`;
